var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 14.891C0 7.096 6.316.78 14.111.78c7.795 0 14.111 6.316 14.111 14.111 0 7.795-6.316 14.111-14.11 14.111C6.315 29.002 0 22.686 0 14.892zm6.457-.306c-.932.365-.916.881-.16 1.121l3.483 1.087 8.08-5.087c.375-.25.723-.109.439.142l-6.539 5.907-.25 3.59c.364 0 .523-.16.711-.347l1.702-1.64 3.528 2.6c.643.365 1.103.177 1.274-.597l2.317-10.914-.001.001c.204-.954-.347-1.337-.979-1.108z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.e621e43e91ef82b705e53a124d67bb32.svg";
export { ForwardRef as ReactComponent };